import { Box, styled } from '@mui/material';
import { ReactNode } from 'react';
import { DotSeparator } from '../../../shared/dot-separator/dot-separator.styles';

export interface DotSeparatedTitleProps {
  leftTitle: ReactNode;
  rightTitle: ReactNode;
  children?: ReactNode;
}

export const PatientProfileWidgetWrapper = styled('div')({
  fontFamily: 'Roboto',
  fontSize: '12px',
  letterSpacing: '0.15px',
  color: 'rgba(28, 61, 100, 1)',
  backgroundColor: 'white',
  margin: 0,
  padding: 0,
  cursor: 'default',
  height: '100%',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column'
});

export const VerticalSeparator = styled(() => <span style={{ padding: '0 8px' }}>|</span>)();

export const HorizontalSeparator = styled('div')({
  borderBottom: 'solid 1px rgba(233, 234, 238, 1)',
  margin: '0 16px',
  listStyle: 'none'
});

export const List = styled('ul')({
  padding: 0,
  margin: 0,
  color: 'rgba(28, 61, 100, 1)',
  backgroundColor: 'rgba(255, 255, 255, 1)'
});

export const ListItem = styled((props: any) => {
  return (
    <li style={{ cursor: 'pointer', padding: '10px 0', margin: '0 10px', listStyle: 'none' }} {...props}>
      <Box
        className="list-item"
        sx={{
          padding: '10px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'start',
          '&:hover': { backgroundColor: 'rgba(235, 245, 255, 1)', borderRadius: '4px' }
        }}
      >
        {props.icon && (
          <CircleIcon className="icon" sx={{ marginRight: '12px' }}>
            {props.icon}
          </CircleIcon>
        )}
        {props.children && <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>{props.children}</Box>}
      </Box>
    </li>
  );
})((props: any) => ({}));

export const CircleIcon = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  fontSize: '12px',
  borderRadius: '50%',
  width: '34px',
  height: '34px',
  color: 'rgba(28, 61, 100, 0.8)',
  backgroundColor: '#e9ecf0',
  justifyContent: 'center',
  '& svg': {
    fontSize: '18px'
  }
});

export const EmptyList = styled('div')({
  display: 'flex',
  margin: '100px auto 0 auto',
  fontSize: '16px'
});

export const LiSeparator = styled('li')({
  borderBottom: 'solid 1px rgba(233, 234, 238, 1)',
  margin: '0 16px',
  listStyle: 'none'
});

export const DotSeparatedTitle = styled((props: DotSeparatedTitleProps) => (
  <Box
    className="dot-sepatared-title"
    sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', color: 'rgba(28, 61, 100, 1)' }}
  >
    <Box className="dot-sepatared-title-left" sx={{ fontWeight: 500 }}>
      {props.leftTitle}
    </Box>
    {props.leftTitle && props.rightTitle && <DotSeparator>•</DotSeparator>}
    {props.rightTitle}
  </Box>
))((props: any) => ({}));

export const StandardStatus = styled(Box)({
  color: 'rgba(97, 108, 121, 1)'
});

export const SuccessStatus = styled(Box)({
  color: 'rgba(0, 138, 6, 1)'
});

export const CompleteStatus = styled(Box)({
  color: 'rgba(6, 117, 221, 1)'
});

export const PendingStatus = styled(Box)({
  color: 'rgba(0, 71, 99, 1)'
});

export const ErrorStatus = styled(Box)({
  color: '#E25650'
});
